<template>
  <div class="infoblock d-flex" :class="{ 'mt-4': !noMargin }" :style="getStyle">
    <div :class="`left ${color}`" />
    <div
      :class="`right ${color} d-flex align-items-center w-100 ${appendIcon ? 'justify-content-between' : ''}`"
    >
      <VTooltip
        v-if="prependIcon && prependTooltipMessage"
        right
      >
        <template #activator="{ on, attrs }">
          <VIcon
            :color="prependIconColor"
            dark
            v-bind="attrs"
            v-on="on"
            class="ml-2"
          >
            {{ prependIcon }}
          </VIcon>
        </template>
        <span>{{ prependTooltipMessage }}</span>
      </VTooltip>
      <VIcon
        v-else-if="prependIcon && !prependTooltipMessage"
        :color="prependIconColor"
        light
        class="ml-2"
      >
        {{ prependIcon }}
      </VIcon>
      <span class="hint body-1 textPrimary--text py-1 px-2" v-html="message" />
      <VTooltip
        v-if="appendIcon && appendTooltipMessage"
        right
      >
        <template #activator="{ on, attrs }">
          <VIcon
            :color="appendIconColor"
            dark
            v-bind="attrs"
            v-on="on"
            class="mr-2"
          >
            {{ appendIcon }}
          </VIcon>
        </template>
        <span>{{ appendTooltipMessage }}</span>
      </VTooltip>
      <VIcon
        v-else-if="appendIcon && !appendTooltipMessage"
        :color="appendIconColor"
        dark
        class="mr-2"
      >
        {{ appendIcon }}
      </VIcon>
    </div>
  </div>
</template>
<script lang="ts">
export default {
  name: 'SInfoblock',
};
</script>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps({
  prependIcon: {
    type: String,
    default: null,
  },
  prependIconColor: {
    type: String,
    default: '',
  },
  appendIcon: {
    type: String,
    default: null,
  },
  appendIconColor: {
    type: String,
    default: '',
  },
  noMargin: {
    type: Boolean,
    default: false,
  },
  message: {
    type: String,
    default: '',
  },
  prependTooltipMessage: {
    type: String,
    default: '',
  },
  appendTooltipMessage: {
    type: String,
    default: '',
  },
  color: {
    type: String,
    default: 'blue-color',
  },
  height: {
    type: String,
    default: 'auto',
  },
});

const getStyle = computed(() => ({
  'height': `${props.height}`,
}));
</script>
<style lang="scss" scoped>
.infoblock {
  border-radius: 8px;

  .left {
    width: 8px;
    border-radius: 8px 0px 0px 8px;

    &.blue-color {
      background: var(--v-secondary-base) !important;
    }

    &.green-color {
      background: var(--v-success-base) !important;
    }

    &.warning-color {
      background: var(--v-warning-base) !important;
    }

    &.error-color {
      background: #DF4321 !important;
    }
  }

  .right {
    border-radius: 0 8px 8px;

    &.blue-color {
      background: rgb(6, 148, 211, 0.1);
    }

    &.green-color {
      background: rgb(232, 236, 2, 0.1);
    }

    &.warning-color {
      background: rgba(255, 243, 229, 1);
    }

    &.error-color {
      background: #fdece9;
    }
  }
}
</style>
